import {
	autoUpdate,
	flip,
	offset,
	shift,
	useDismiss,
	useFloating,
	useFocus,
	useHover,
	useInteractions,
	useRole,
} from '@floating-ui/react'
import { memo, useEffect, useMemo, useState } from 'react'
import { useDispatch } from 'react-redux'
import { NavLink, useLocation } from 'react-router-dom'
import { toggleSidebar } from 'store/ui'
import styled from 'styled-components'
const StyledLink = styled.li`
	display: flex;
	height: 48px;
	margin: 0;
	width: 100%;
	& a {
		align-items: center;
		border-radius: 10px;
		color: #292a32;
		display: flex;
		height: 100%;
		outline: none;
		padding: 12px;
		width: 100%;
		&:hover,
		&.active {
			background-color: #f1f5f9;
			color: #018ecc;
			& .icon {
				color: #018ecc;
			}
		}
		&[data-collapsed='true'] {
			border-radius: 24px;
			justify-content: center;
			& .icon {
				margin: 0;
			}
			& .label {
				display: none;
			}
		}
		& .icon {
			color: #adadad;
			height: 24px;
			margin: 0 8px 0 0;
			width: 24px;
		}
		& .label {
			font-size: 16px;
			font-weight: 500;
			max-width: calc(100% - 32px);
			min-width: calc(100% - 32px);
			text-align: left;
			width: calc(100% - 32px);
			white-space: nowrap;
		}
	}
	.dark & a {
		color: #e1e1e1;
		&:hover,
		&.active {
			background-color: #4b4b4b;
			color: #018ecc;
			& .icon {
				color: #018ecc;
			}
		}
	}
`
const Link = memo(
	({
		isLargeWindow,
		collapsed = false,
		icon,
		label = '',
		path = '',
		setActiveIndex,
		index,
	}) => {
		const { pathname } = useLocation()
		const [isOpen, setIsOpen] = useState(false)
		const { refs, floatingStyles, context } = useFloating({
			onOpenChange: setIsOpen,
			open: isOpen,
			placement: 'right',
			whileElementsMounted: autoUpdate,
			middleware: [
				shift(),
				offset(6),
				flip({
					fallbackAxisSideDirection: 'start',
				}),
			],
		})
		const dispatch = useDispatch()
		const dismiss = useDismiss(context)
		const focus = useFocus(context, { enabled: collapsed })
		const hover = useHover(context, {
			enabled: collapsed,
			move: false,
		})
		const role = useRole(context, { role: 'tooltip' })
		const { getReferenceProps, getFloatingProps } = useInteractions([
			dismiss,
			focus,
			hover,
			role,
		])
		const dataCY = useMemo(() => `link-sidebar-${path}`, [path])
		useEffect(() => {
			const isActive =
				path === pathname || String(pathname).startsWith((path || '') + '/')
			if (isActive) {
				setActiveIndex(index)
			}
		}, [pathname, index, setActiveIndex, path])
		return (
			<StyledLink>
				<NavLink
					{...getReferenceProps()}
					data-cy={dataCY}
					ref={refs.setReference}
					to={path}
					onClick={() => !isLargeWindow && dispatch(toggleSidebar(true))}
				>
					<div className='icon'>{icon}</div>
					<div className='label'>{label}</div>
				</NavLink>
			</StyledLink>
		)
	}
)
export default Link
